// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicWebHomepage } from "./plasmic/o_21_p_0_0_0_prod/PlasmicWebHomepage";
import { Helmet } from "react-helmet-async";

function WebHomepage_(props, ref) {
  return (
        <>
          <Helmet>
            
          </Helmet>
    
          <PlasmicWebHomepage root={{ ref }} {...props} />
        </>
      );
}

const WebHomepage = React.forwardRef(WebHomepage_);

export default WebHomepage;
